import {inject, Injectable} from '@angular/core';
import {Observable, map, of, switchMap} from 'rxjs';
import {DATABASE_NAME} from 'src/app/config/app.config';
import {LOCAL_DATABASE} from 'src/app/core/enums/storage/local-database.enum';
import {STORE_DATABASE} from 'src/app/core/enums/storage/store-database.enum';
import {IndexedDBRepository} from 'src/app/shared/interface/indexed-db-storage.model';
import {Ticket} from '../../domain/model/ticket.model';
import {IApiTicket} from '../interfaces/ticket-api.interface';
import {TicketMapper} from '../mapper/ticket.mapper';
import {TicketFactoryService} from './ticket-factory.service';

@Injectable({providedIn: 'root'})
export class TicketSessionService extends IndexedDBRepository<IApiTicket> {
  readonly dbName = DATABASE_NAME;
  readonly instanceName = STORE_DATABASE.session;
  private readonly sessionKey = LOCAL_DATABASE.lastTicket;
  private readonly ticketFactoryService = inject(TicketFactoryService);

  get(): Observable<Ticket | null> {
    return this.getItem(this.sessionKey).pipe(
      switchMap((item) =>
        item ? this.ticketFactoryService.createOne(item, true) : of(null)
      )
    );
  }

  save(ticket: Ticket): Observable<void> {
    if (!ticket) {
      return of(void 0)
    }

    return this.setItem(this.sessionKey, TicketMapper.toJSON(ticket)).pipe(
      map(() => undefined)
    );
  }

  delete(): Observable<void> {
    return this.removeItem(this.sessionKey);
  }
}
